import { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Usluga = ({ service }) => {
  const {
    title,
    firstQuestion,
    firstAnswer,
    secondQuestion,
    secondAnswer,
    thirdQuestion,
    thirdAnswer,
    img,
  } = service;

  const [isShowFirstAnswer, setFirstAnswer] = useState(false);
  const [isShowSecondAnswer, setSecondAnswer] = useState(false);
  const [isShowThirdAnswer, setThirdAnswer] = useState(false);

  const showFirstAnswer = () => {
    setFirstAnswer(!isShowFirstAnswer);
  };

  const showSecondAnswer = () => {
    setSecondAnswer(!isShowSecondAnswer);
  };

  const showThirdAnswer = () => {
    setThirdAnswer(!isShowThirdAnswer);
  };

  return (
    <div className="service" id="service">
      <Header />
      <div className="service-all-page">
        <div className="service-title">{title}</div>
        <div className="service-page">
          <div className="service-left">
            <img
              src={`/images/${img}.jpg`}
              className="triotim-service-left"
              alt="triotim"
            />
          </div>
          <div className="service-right">
            <div className="service-right-all-text">
              <div className="service-right-text" onClick={showFirstAnswer}>
                {firstQuestion}
              </div>
              {isShowFirstAnswer ? (
                <div className="service-right-text-answer">{firstAnswer}</div>
              ) : (
                ""
              )}
              <div className="service-right-text" onClick={showSecondAnswer}>
                {secondQuestion}
              </div>
              {isShowSecondAnswer ? (
                <div className="service-right-text-answer">{secondAnswer}</div>
              ) : (
                ""
              )}

              <div className="service-right-text" onClick={showThirdAnswer}>
                {thirdQuestion}
              </div>
              {isShowThirdAnswer ? (
                <div className="service-right-text-answer">{thirdAnswer}</div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Usluga;
